import React from 'react';
import styled from 'styled-components';
import { PersonalityTypes } from 'Types/PersonTypes';
import {
  boxShadow,
  maxWidth,
  primaryColor,
  primaryFont, retina, wMBold, wMedium,
} from 'Utils/utilsStyle';
import EngagementProfileWidget from './EngagementProfileWidget';

const Body = styled.div`
  display: flex;
  align-items: center;
  box-shadow: ${boxShadow};
  border-radius: 10px;
  background: #fff;
  padding: 18px 14px;
  margin-bottom: 10px;
  .body-item {
    min-width: 20%;
    width: 20%;
    font-size: 20px;
    font-weight: ${wMBold};
    font-family: ${primaryFont};
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 16px;
    }
    color: #424B50;
    &:nth-child(1) {
    min-width: 40%;
    width: 40%;
    }
    &:nth-child(3), &:nth-child(4) {
     text-align: center;
    }
    &.body-profile {

    }
    &.body-accounts {
      font-size: 16px;
      color: ${primaryColor};
      font-weight: ${wMedium};
    }
  }
`;

type Props = {
  wrapperColor: PersonalityTypes[],
  image: string,
  persona: string,
  personId: number,
  companyId: number,
  companyName: string,
  title: string,
  actionAddBtn: () => void
  subscribed: boolean;
  views: number;
  downloads: number;
  personType: string;
} | typeof defaultProps;

const defaultProps = {
  wrapperColor: [],
  image: '',
  persona: '',
  personId: 0,
  companyId: 0,
  companyName: '',
  title: '',
  actionAddBtn() { },
  subscribed: false,
  views: 0,
  downloads: 0,
  personType: '',
};

const EngagementPeopleTableBody = function EngagementPeopleTableBody(props: Props) {
  const {
    personId, persona, image, title, actionAddBtn, wrapperColor, companyId,
    subscribed, views, downloads, companyName, personType,
  } = props;
  return (
    <Body>
      <div className="body-item body-profile">
        <EngagementProfileWidget
          personId={personId}
          companyId={companyId}
          persona={persona}
          image={image}
          title={title}
          actionAddBtn={actionAddBtn}
          wrapperColor={wrapperColor}
          subscribed={subscribed}
          personType={personType}
          openInNewTab
        />
      </div>
      <div className="body-item body-accounts">{companyName}</div>
      <div className="body-item">{views}</div>
      <div className="body-item">{downloads}</div>
    </Body>
  );
};

EngagementPeopleTableBody.defaultProps = defaultProps;
export default EngagementPeopleTableBody;
